import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSParser from 'css-js';
import { isString as _isString, find as _find } from 'lodash';

import RichEditorContent from 'components/RichEditorContent';

class EmailPreview extends React.Component {
  getHeader = () => {
    const { projectConfig } = this.props;

    return (
      <div>
        <Row>
          <Col xs={12}>
            <div style={{ height: '16px' }} />
          </Col>
        </Row>

        <Row>
          <Col xs={8} xsOffset={2} class="email-container">
            <div style={{ height: '16px' }} />

            <a href="#logo">
              <center>
                <img
                  src={this.getLogoForMail()}
                  alt={((projectConfig.data && projectConfig.data.name) || projectConfig.getName()) + ' Logo'}
                  height="30"
                />
              </center>
            </a>

            <div style={{ height: '10px' }} />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div style={{ height: '16px' }} />
          </Col>
        </Row>
      </div>
    );
  };

  getContent = () => {
    const {
      intl: { messages },
      appIntl,
      systemMail,
      content,
    } = this.props;

    let langContent = '';
    if (_isString(content)) {
      langContent = content;
    } else {
      langContent = _find(content, ['lang', appIntl.displayIntlForm]);
      if (langContent && langContent.description) {
        langContent = langContent.description;
      } else {
        langContent = null;
      }
    }

    const text = systemMail && systemMail.id && !langContent ? messages.mail[systemMail.id].explanation : langContent;

    return <RichEditorContent content={'<div>' + this.processContent(text) + '</div>'} />;
  };

  processContent = text => {
    const { projectConfig } = this.props;

    const mapObj = {
      '%firstName%': 'Max',
      '%lastName%': 'Mustermann',
      '%company%': (projectConfig.data && projectConfig.data.name) || projectConfig.getName(),
    };

    const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');
    const str =
      (text !== undefined &&
        text !== null &&
        text.replace(re, matched => {
          return mapObj[matched];
        })) ||
      '';

    return str;
  };

  getFooter = () => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <div>
        <Row>
          <Col xs={12}>
            <div style={{ height: '16px' }} />
          </Col>
        </Row>

        <Row>
          <Col xs={8} xsOffset={2} class="email-container">
            <div style={{ height: '16px' }} />

            <p class="text-center">
              Copyright {(projectConfig.data && projectConfig.data.name) || projectConfig.getName()}
              <br />
              <a href="mailto:">email@sender.com</a> |{' '}
              <a href="#manageNotification">{messages.mail.manage_notification}</a> |{' '}
              <a href="#unsubscribe">{messages.mail.unsubscribe}</a>
            </p>
            <div class="text-center" />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div style={{ height: '16px' }} />
          </Col>
        </Row>
      </div>
    );
  };

  getLogoForMail = () => {
    const { projectConfig } = this.props;

    const useMailLogo =
      (projectConfig.data && projectConfig.data.use_mail_logo === 'mail') ||
      (projectConfig.getUseMailLogo && projectConfig.getUseMailLogo() === 'mail');
    const hasMailLogo =
      (projectConfig.data && projectConfig.data.mail_logo && projectConfig.data.mail_logo.variations) ||
      (projectConfig.getMailLogo && projectConfig.getMailLogo() && projectConfig.getMailLogo().getVariations());
    if (useMailLogo && hasMailLogo) {
      const dataLogo = _find(
        projectConfig.data && projectConfig.data.mail_logo && projectConfig.data.mail_logo.variations,
        ['variation_type', 'web']
      );
      if (dataLogo) {
        return dataLogo.file.web_link;
      }

      const entityLogo = _find(
        projectConfig.getMailLogo && projectConfig.getMailLogo() && projectConfig.getMailLogo().getVariations(),
        ['variationType', 'web']
      );
      if (entityLogo) {
        return dataLogo.getFile().getWebLink();
      }
    }

    const useScrollLogo =
      (projectConfig.data && projectConfig.data.use_mail_logo === 'scroll') ||
      (projectConfig.getUseMailLogo && projectConfig.getUseMailLogo() === 'scroll');
    const hasScrollLogo =
      (projectConfig.data && projectConfig.data.scroll_logo && projectConfig.data.scroll_logo.variations) ||
      (projectConfig.getScrollLogo && projectConfig.getScrollLogo() && projectConfig.getScrollLogo().getVariations());
    if (useScrollLogo && hasScrollLogo) {
      const dataLogo = _find(
        projectConfig.data && projectConfig.data.scroll_logo && projectConfig.data.scroll_logo.variations,
        ['variation_type', 'web']
      );
      if (dataLogo) {
        return dataLogo.file.web_link;
      }

      const entityLogo = _find(
        projectConfig.getScrollLogo && projectConfig.getScrollLogo() && projectConfig.getScrollLogo().getVariations(),
        ['variationType', 'web']
      );
      if (entityLogo) {
        return dataLogo.getFile().getWebLink();
      }
    }

    if (
      (projectConfig.data && projectConfig.data.main_logo && projectConfig.data.main_logo.variations) ||
      (projectConfig.getMainLogo && projectConfig.getMainLogo() && projectConfig.getMainLogo().getVariations())
    ) {
      const dataLogo = _find(
        projectConfig.data && projectConfig.data.main_logo && projectConfig.data.main_logo.variations,
        ['variation_type', 'web']
      );
      if (dataLogo) {
        return dataLogo.file.web_link;
      }

      const entityLogo = _find(
        projectConfig.getMainLogo && projectConfig.getMainLogo() && projectConfig.getMainLogo().getVariations(),
        ['variationType', 'web']
      );
      if (entityLogo) {
        return dataLogo.getFile().getWebLink();
      }
    }

    return '/img/chedri_logo.png';
  };

  getStyle = () => {
    let style = '';
    style += '.email-preview .email-body { background: #f3f3f3; } ';
    style += '.email-preview .email-container { background: #fefefe; } ';

    style += this.getProjectStyle();

    return style;
  };

  getProjectStyle = () => {
    const { projectConfig } = this.props;

    const customCssMail =
      (projectConfig.data && projectConfig.data.custom_css_mail) ||
      (projectConfig.getCustomCssMail && projectConfig.getCustomCssMail());
    let style = '';
    if (customCssMail) {
      const parser = new CSSParser({ ver: '3.0' });

      let ast;
      try {
        ast = parser.parse(customCssMail);
      } catch (err) {
        return '';
      }

      for (let i = 0; i < ast.rulesets.length; i++) {
        style += '.email-preview ' + ast.rulesets[i].selector.replace('table.', '.email-') + ' { ';

        for (let j = 0; j < ast.rulesets[i].declaration.length; j++) {
          style += ast.rulesets[i].declaration[j].key + ': ' + ast.rulesets[i].declaration[j].value + '; ';
        }

        style += ' } ';
      }
    }

    return style;
  };

  render() {
    const {
      intl: { messages },
      systemMail,
    } = this.props;

    return (
      <div class="email-preview">
        <div class="email-body">
          <style type="text/css" dangerouslySetInnerHTML={{ __html: this.getStyle() }} />

          <Grid fluid>
            {this.getHeader()}

            <Row>
              <Col xs={8} xsOffset={2} class="email-container">
                {this.getContent()}

                {!!systemMail && !!systemMail.id && (
                  <div class="m-t-15 m-b-15 padding-20 bg-master-lightest text-center text-uppercase">
                    {messages.call_to_action}
                  </div>
                )}
              </Col>
            </Row>

            {this.getFooter()}
          </Grid>
        </div>
      </div>
    );
  }
}
EmailPreview.defaultProps = {
  systemMail: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(EmailPreview));
